<script setup lang="ts">
/**
 * BrandWordmark — theme-aware wordmark (ADR-074).
 *
 * Renders both variants; `main.css` hides `.wordmark--on-light` under
 * `[data-theme='dark']` and `.wordmark--on-dark` otherwise, so the swap needs
 * no script and no flash. Attributes ($attrs — alt, width, height, class,
 * loading) are forwarded to both `<img>`s.
 */
import wordmarkDark from '@/assets/brand/wordmark.svg'
import wordmarkLight from '@/assets/brand/wordmark-light.svg'
defineOptions({ inheritAttrs: false })
</script>
<template>
  <img :src="wordmarkDark" v-bind="$attrs" class="wordmark--on-dark" />
  <img :src="wordmarkLight" v-bind="$attrs" class="wordmark--on-light" />
</template>
